<style lang="scss" scoped>
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  right: -10px;
  top: 28px;
  background-color: #FFFFFF;
  min-width: 160px;
  box-shadow: 0 2px 8px 0 rgba(0,0,0,0.12);
  border: 1px solid #F3F6F9;
  border-radius: 4px;
  z-index: 1;
  color: #004373;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 16px;
  padding: 20px 0 0 16px;
}

.dropdown:hover .dropdown-content {
  display: block;
  background-color: #F3F6F9;
}

.dropdown-content a{
  padding: 0 0 16px 0;
}

.dropdown-content a:hover{
  background-color: #F3F6F9;
}
.dropdown-title{
  color: #FFFFFF;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 16px;
  padding: 0 0 20px 0;
}
.dropdown-title:after{
  content: "▾";
  font-size: 10px;
  position: absolute;
  padding: 2.5px 0 0 4px;
}
.dropdown-title:hover{
  color: #F99337;
}
.positive .dropdown-title, .nav-sticky .dropdown-title{
  color: #004373;;
}
.active-language{
  color: #F99337;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 16px;
}
</style>

<template>
    <div class="dropdown" id="languageNav">
      <a class="uppercase dropdown-title">{{ val }}</a>
      <div class="dropdown-content">

        <span  class="flex flex-col">
          <a :class='val == "nl" ? "active-language" : ""' href="/">Nederlands</a>
          <a :class='val == "fr" ? "active-language" : ""' href="/fr">Français</a>
          <a :class='val == "en" ? "active-language" : ""' href="/en">English</a>
        </span>

      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: {
    val: {
      type: String
    },
  },
  methods: {
  }
}
</script>
